import React from "react";

export default function OutdoorFaqList({ faqs }) {
  return (
    <div className="max-w-3xl divide-y divide-border border-y border-border">
      {faqs.map((f, i) => (
        <details key={i} className="py-6 group">
          <summary className="flex items-center justify-between cursor-pointer list-none">
            <span className="font-heading text-lg font-semibold pr-4">{f.question}</span>
            <span className="text-accent text-2xl font-light group-open:rotate-45 transition-transform">+</span>
          </summary>
          <p className="mt-4 text-muted-foreground font-light leading-relaxed">{f.answer}</p>
        </details>
      ))}
    </div>
  );
}